<div  *ngIf="(branchUnitOverview)">
<h3 > Unit is {{ GetUnitStatus(mrx_adrzstat) }} </h3>

  <div id="wrapnumber">
    <div  id="one" *ngIf="branchUnitOverview.ecsupplypresent.constvalue.value">
      <h2 > EC Supply: <i>   {{ GetValue(ecsupplysetpoint) }}</i> </h2>
      <kendo-arcgauge style="display:block;height:125px;width:125px;"  [value]="ecsupplymeasurement.val" [scale]="{ min: 0, max: 6.0 }">
        <ng-template   kendoArcGaugeCenterTemplate   let-value="value" >
          <span >{{ GetValue(ecsupplymeasurement) }} <app-unit *ngIf="branchUnitOverview" [unit]="branchUnitOverview.ecsupplymeasurement.variable.unit"></app-unit></span>
        </ng-template>
      </kendo-arcgauge>
    </div>

    <div  id="two" *ngIf="branchUnitOverview.ecdosagepresent.constvalue.value">
      <h2 > EC Dosage: <i>   {{ GetValue(ecdosagesetpoint) }}</i> </h2>
      <kendo-arcgauge style="padding:1px;display:block;height:125px;width:125px;"   [value]="ecdosagemeasurement.val" [scale]="{ min:0, max: 6.0 }">
        <ng-template   kendoArcGaugeCenterTemplate   let-value="value" >
          <span > <b>{{ GetValue(ecdosagemeasurement) }}</b>   <app-unit *ngIf="branchUnitOverview" [unit]="branchUnitOverview.ecdosagemeasurement.variable.unit"></app-unit>             </span>
        </ng-template>
      </kendo-arcgauge>
    </div>

    <div  id="three" *ngIf="branchUnitOverview.phpresent.constvalue.value">
      <h2 > pH Dosage : <i>   {{ GetValue(phsetpoint) }}</i> </h2>
      <kendo-arcgauge style="display:block;height:125px;width:125px;"  [value]="phmeasurement.val" [scale]="{ min: 0, max: 10.0 }">
        <ng-template   kendoArcGaugeCenterTemplate   let-value="value" >
          <span >{{ GetValue(phmeasurement) }} <app-unit *ngIf="branchUnitOverview" [unit]="branchUnitOverview.phsetpoint.variable.unit"></app-unit></span>
        </ng-template>
      </kendo-arcgauge>
    </div>

    <div  id="four" *ngIf="branchUnitOverview.flowpresent.constvalue.value">
      <h2 > Flow : <i>   {{ GetValue(flowsetpoint) }}</i> </h2>
      <kendo-arcgauge style="display:block;height:125px;width:125px;"  [value]="flowmeasurement.val" [scale]="{ min: 0, max: 10.0 }">
        <ng-template   kendoArcGaugeCenterTemplate   let-value="value" >
          <span >{{ GetValue(flowmeasurement) }} <app-unit *ngIf="branchUnitOverview" [unit]="branchUnitOverview.flowsetpoint.variable.unit"></app-unit></span>
        </ng-template>
      </kendo-arcgauge>
    </div>

  <div  id="five" *ngIf="1">


  mrx_adrgifte &nbsp; {{ mrx_adrgifte.val }}   <br/>
  mrx_adrpomps  {{ mrx_adrpomps.val  }}  <br/>
  mrx_noggeven  {{ mrx_noggeven.val  }}  <br/>
    mrx_adrzstat {{ mrx_adrzstat.val  }}  <br/>
    </div>


</div>
</div>
